/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Fix for cart page header being hidden by apps or scripts
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the cart page
  if (document.body.classList.contains('template-cart') || window.location.pathname.includes('/cart')) {
    
    console.log('Cart page detected - monitoring page header visibility');
    
    // Function to ensure page header is visible
    function ensureHeaderVisible() {
      var pageHeaders = document.querySelectorAll('.page__header, header.page__header');
      pageHeaders.forEach(function(header) {
        if (header.style.display === 'none') {
          console.log('Found hidden page header, fixing...', header);
          header.style.display = 'block';
          console.log('Fixed hidden page header on cart page');
        }
      });
    }
    
    // Function to log current header styles
    function logHeaderStyles() {
      var pageHeaders = document.querySelectorAll('.page__header, header.page__header');
      pageHeaders.forEach(function(header, index) {
        console.log('Header ' + index + ' styles:', {
          display: header.style.display,
          visibility: header.style.visibility,
          computedDisplay: window.getComputedStyle(header).display,
          classes: header.className
        });
      });
    }
    
    // Run immediately
    ensureHeaderVisible();
    logHeaderStyles();
    
    // Run after delays to catch any scripts that run after DOM load
    setTimeout(function() {
      console.log('Checking header after 100ms...');
      ensureHeaderVisible();
      logHeaderStyles();
    }, 100);
    
    setTimeout(function() {
      console.log('Checking header after 500ms...');
      ensureHeaderVisible();
      logHeaderStyles();
    }, 500);
    
    setTimeout(function() {
      console.log('Checking header after 1000ms...');
      ensureHeaderVisible();
      logHeaderStyles();
    }, 1000);
    
    // Set up a mutation observer to watch for style changes
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          var target = mutation.target;
          if (target.classList.contains('page__header') && target.style.display === 'none') {
            console.log('Detected attempt to hide page header - preventing...', target);
            target.style.display = 'block';
            console.log('Prevented page header from being hidden');
          }
        }
      });
    });
    
    // Start observing
    var pageHeaders = document.querySelectorAll('.page__header, header.page__header');
    pageHeaders.forEach(function(header) {
      observer.observe(header, { attributes: true, attributeFilter: ['style'] });
    });
  }
});

